export function separatorModule(user) {
  if (user.dbschema == "superpao") {
    return "|";
  }
  return ";";
}
